import type { App } from './App';

interface GuideStep {
  id: number;
  title: string;
  description: string;
  image: string;
}

export class GuideModal {
  private el: HTMLElement;
  private app: App;
  private steps: GuideStep[] = [];
  private currentStep = 0;

  constructor(container: HTMLElement, app: App) {
    this.app = app;
    this.el = document.createElement('div');
    this.el.className = 'guide-modal-wrap';
    container.appendChild(this.el);
    this.loadData();
  }

  private async loadData() {
    try {
      const resp = await fetch('/guide/data.json');
      this.steps = await resp.json();
      this.render();
    } catch (e) {
      console.error('Failed to load guide data', e);
      this.el.innerHTML = '<div class="guide-error">가이드를 불러오지 못했어요.</div>';
    }
  }

  private render() {
    const step = this.steps[this.currentStep];
    if (!step) return;

    this.el.innerHTML = `
      <div class="guide-modal">
        <div class="guide-header">
          <div class="guide-progress">
            ${this.steps.map((_, i) => `
              <div class="progress-dot ${i === this.currentStep ? 'active' : ''} ${i < this.currentStep ? 'done' : ''}"></div>
            `).join('')}
          </div>
          <button class="btn-guide-nav" id="btn-guide-video" title="영상으로 보기">🎬 영상으로 보기</button>
          <button class="btn-icon-sm" id="btn-close-guide">✕</button>
        </div>
        
        <div class="guide-body">
          <div class="guide-image-container">
            <img src="/guide/${step.image}" alt="${step.title}" class="guide-image" />
          </div>
          <div class="guide-content">
            <h3 class="guide-title">${step.title}</h3>
            <p class="guide-desc">${step.description}</p>
          </div>
        </div>

        <div class="guide-footer">
          <button class="btn-guide-nav" id="btn-prev" ${this.currentStep === 0 ? 'disabled' : ''}>
            <span>←</span> 이전
          </button>
          <div class="step-counter">${this.currentStep + 1} / ${this.steps.length}</div>
          ${this.currentStep === this.steps.length - 1 
            ? '<button class="btn-guide-finish" id="btn-finish">시작하기! ✨</button>'
            : `<button class="btn-guide-nav" id="btn-next">
                 다음 <span>→</span>
               </button>`
          }
        </div>
      </div>
    `;

    this.bindEvents();
  }

  private bindEvents() {
    this.el.querySelector('#btn-close-guide')?.addEventListener('click', () => this.app.closeOverlay());
    // SsamFlow 사용법 가이드(ssamflow.com/js/app-guide.js)의 모션 영상
    this.el.querySelector('#btn-guide-video')?.addEventListener('click', () => {
      this.app.closeOverlay();
      (window as unknown as { SFGuide?: { open: (part: string) => void } }).SFGuide?.open('all');
    });
    this.el.querySelector('#btn-finish')?.addEventListener('click', () => this.app.closeOverlay());
    
    this.el.querySelector('#btn-prev')?.addEventListener('click', () => {
      if (this.currentStep > 0) {
        this.currentStep--;
        this.render();
      }
    });

    this.el.querySelector('#btn-next')?.addEventListener('click', () => {
      if (this.currentStep < this.steps.length - 1) {
        this.currentStep++;
        this.render();
      }
    });
  }

  destroy() {
    this.el.remove();
  }
}
